<form class="popupForm" style="min-height: 300px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <span *ngIf="!this.item">{{'date_and_time' | GetLabelPipe}}</span>
      <span *ngIf="this.item">{{'date_and_time' | GetLabelPipe}}</span>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important; min-height: 300px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        &gt;.&lt; error. <br>{{errMsg}}
      </div>
      <div *ngIf="state==='edit'">
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.message">
          <mat-icon color="warn">error</mat-icon><span>{{ validationResult.message }}</span>
          <br>
        </div>
        <div>
          &nbsp;
        </div>

        <div>{{'event_start_time' | GetLabelPipe}}</div>
        <div class="flex-row-center flex-justify-space-between">
          <mat-form-field appearance="outline" color="accent" style="width: 55%">
            <input matInput [matDatepicker]="pickerStartDay" [disabled]="datesDisabled"
                   (click)="dateInputClick($event,pickerStartDay)"
                   (dateInput)="dateChangeEvent($event,true)"
                   formControlName="eventStartInput" #eventStartInputElem>
            <mat-datepicker-toggle matSuffix [for]="pickerStartDay"></mat-datepicker-toggle>
            <mat-datepicker touchUi #pickerStartDay></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" color="accent" style="width: 40%">
            <mat-label>{{'hours' | GetLabelPipe}}</mat-label>
            <select matNativeControl formControlName="eventHourStart" (change)="hourChange(true)">
              <ng-container *ngFor="let hour of this.hours; let i = index">
                <option *ngIf="i < this.hours.length-1 " value="{{hour}}">{{hour}}</option>
              </ng-container>
            </select>
          </mat-form-field>
        </div>

        <br>
        <div>{{'event_end_time' | GetLabelPipe}}</div>
        <div class="flex-row-center flex-justify-space-between">
          <mat-form-field appearance="outline" color="accent" style="width: 55%">
            <input matInput [matDatepicker]="pickerEndDay" [disabled]="datesDisabled"
                   (click)="dateInputClick($event,pickerEndDay)"
                   (dateInput)="dateChangeEvent($event,false)"
                   formControlName="eventEndInput" #eventEndInputElem>
            <mat-datepicker-toggle matSuffix [for]="pickerEndDay"></mat-datepicker-toggle>
            <mat-datepicker touchUi #pickerEndDay></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" color="accent" style="width: 40%">
            <mat-label>{{'hours' | GetLabelPipe}}</mat-label>
            <select matNativeControl formControlName="eventHourEnd" (change)="hourChange(false)">
              <ng-container *ngFor="let hour of this.hours; let i = index">
                <option *ngIf="i >= 1" value="{{hour}}">{{hour}}</option>
              </ng-container>
            </select>
          </mat-form-field>
        </div>

        <mat-radio-group matInput formControlName="courtIDXControl" aria-labelledby="example-radio-group-label"
                         class="radio-group">
          <mat-radio-button class="radio-button" *ngFor="let court of courts; let idx = index" [value]="idx">
            <div class="textCut">
              {{court['label']}}
            </div>
          </mat-radio-button>
        </mat-radio-group>

        <br><br>
        <div>
        </div>
      </div>
    </mat-dialog-content>
    <ng-container *ngIf="this.state !== 'loading'">
      <div *ngIf="this.state !== 'loading'" fxLayout="row" fxLayoutAlign="{{this.item ? 'space-between end' : 'end end'}}" fxLayoutGap="10px">
        <div *ngIf="this.item">
          <button type="submit" class="widerButton font16" mat-raised-button color="warn" (click)="deleteEvent()">
            {{'delete' | GetLabelPipe}}
          </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
          <button mat-button class="cancel widerButton font16" (click)="onNoClick()" *ngIf="!this.item">
            {{'cancel' | GetLabelPipe}}
          </button>
          <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
            {{'save' | GetLabelPipe}}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</form>
